/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { llmFeedbackBatchGetCompletionFeedback } from "../../funcs/llmFeedbackBatchGetCompletionFeedback.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.BatchGetCompletionFeedbackRequest$inboundSchema,
};

export const tool$llmFeedbackBatchGetCompletionFeedback: ToolDefinition<
  typeof args
> = {
  name: "llm-feedback-batch-get-completion-feedback",
  description: `Batch retrieve feedback for multiple completions

Retrieves feedback for multiple chat completions in a single batch request.`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await llmFeedbackBatchGetCompletionFeedback(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
